<template>
  <div id="app">
    <div
      class="app-view min-h-screen relative bg-white"
      :class="{'hide-footer': hideFooter}"
    >
      <PageNavigation />
      <transition appear name="fade-fast" mode="out-in">
        <router-view />
      </transition>
      <transition appear name="fade-fast" mode="out-in">
        <PageFooter v-if="!hideFooter"/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageFooter from '@/components/nav/PageFooter.vue';
import PageNavigation from '@/components/nav/PageNavigation.vue';
import {
  configureAPI,
  getAll,
  getHistogramData,
  getSubmissions,
} from '@/services/api';

const localStorageExists = localStorage != null;
export default {
  metaInfo() {
    return {
      ...this.metaInfo,
    };
  },
  components: { PageNavigation, PageFooter },
  data() {
    return {
      metaInfo: {
        ...this.$route.meta,
      },
      options: localStorageExists ? JSON.parse(localStorage.getItem('options')) : {},
      submissions: localStorageExists ? JSON.parse(localStorage.getItem('submissions')) : {},
      bins: localStorageExists ? JSON.parse(localStorage.getItem('bins')) : {},
    };
  },
  computed: {
    ...mapState('base', [
      'hideFooter',
      'selectedLoanTypes',
      'selectedCreditScores',
      'selectedCosignerCreditScores',
      'selectedUniversities',
      'selectedDegrees',
      'selectedRateTypes',
      'selectedRepaymentPlans',
      'selectedLenders',
    ]),
  },
  methods: {
    ...mapActions({
      setAllOptions: 'base/setAllOptions',
      setBins: 'base/setBins',
      setAllSubmissions: 'submission/setAllSubmissions',
      setLoading: 'base/setLoading',
    }),
  },
  mounted() {
    if (window != null) {
      window.onload = () => {
        if (this.bins && this.bins.bins && this.bins.bins.length) {
          this.setBins(this.bins);
        }
        if (this.options && this.options.data) {
          this.setAllOptions(this.options);
        }
        if (this.submissions && this.submissions.data) {
          this.setAllSubmissions(this.submissions);
        }
        const { grecaptcha } = window;
        if (grecaptcha != null) {
          grecaptcha.ready(() => {
            grecaptcha
              .execute(process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY, { action: 'submit' })
              .then((token) => {
                configureAPI({
                  baseURL: process.env.VUE_APP_API_BASE_URL,
                  contentType: 'application/json',
                  accept: 'application/json',
                  recaptcha: token,
                });
                getAll()
                  .then((response) => {
                    if (response) {
                      this.setAllOptions(response);
                      if (localStorageExists) {
                        localStorage.setItem('options', JSON.stringify(response));
                      }
                    }
                    return getSubmissions();
                  })
                  .then((response) => {
                    if (response) {
                      this.setAllSubmissions(response);
                      if (localStorageExists) {
                        localStorage.setItem('submissions', JSON.stringify(response));
                      }
                    }

                    return getHistogramData({
                      hasCosigner: this.$showCosignerCreditScores || false,
                      creditScores: this.selectedCreditScores,
                      cosignerCreditScores: this.selectedCosignerCreditScores,
                      universities: this.selectedUniversities,
                      degreeTypes: this.selectedLoanTypes.map((item) => item.toLowerCase()),
                      rateTypes: this.selectedRateTypes,
                      repaymentPlans: this.selectedRepaymentPlans,
                      lenders: this.selectedLenders,
                    });
                  })
                  .then((response) => {
                    if (response) {
                      if (localStorageExists) {
                        localStorage.setItem('bins', JSON.stringify(response.data));
                      }
                      this.setBins(response.data);
                      this.setLoading(false);
                      this.$root.$emit('dataLoaded');
                    }
                  })
                  .catch(() => {
                    this.setLoading(false);
                    this.$root.$emit('dataError');
                  });
              });
          });
        }
      };
    }
  },
  watch: {
    $route(to) {
      this.metaInfo = {
        ...this.metaInfo,
        ...to.meta,
      };
    },
  },
};
</script>
